import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Support() {
  const { t } = useTranslation("global");

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">{t('support.title')}</h2>
      <p className="text-center mb-5">{t('support.subtitle')}</p>

      <div className="mb-4">
        <h4>{t('support.account.title')}</h4>
        <p>{t('support.account.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('support.course.title')}</h4>
        <p>{t('support.course.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('support.zoom.title')}</h4>
        <p>{t('support.zoom.description')}</p>
      </div>
    </div>
  );
}
